import i18n from 'i18next';
import { DEFAULT_LOCALE } from 'common/constants/default-locale';
export var getLocale = function () {
    return i18n.language ||
        (typeof window !== 'undefined' && window.localStorage.i18nextLng) ||
        navigator.language ||
        DEFAULT_LOCALE;
};
